import { render, staticRenderFns } from "./AppAccessDenied.vue?vue&type=template&id=46a37ad2&scoped=true&"
import script from "./AppAccessDenied.vue?vue&type=script&lang=js&"
export * from "./AppAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a37ad2",
  null
  
)

export default component.exports